// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jTHV","label":"styles_label__RzTu4"};